<template>
  <v-container>
    <v-form @submit.prevent="submit">
      <v-text-field v-model="task" autofocus label="Task" :rules />
      <v-textarea v-model="description" label="Description" />
      <v-btn :disabled="!task" type="submit">Submit</v-btn>
    </v-form>
  </v-container>
</template>
<script setup lang="ts">
import type { SubmitEventPromise } from "vuetify";
import { ref } from "vue";
import { useIssueCreateIssue } from "../gen/forgejo-vue";
import { useRouter } from "vue-router";

const props = defineProps<{
  owner: string;
  repo: string;
}>();
const emit = defineEmits<(e: "created") => void>();
const router = useRouter();

const task = ref("");
const description = ref("");

const rules = [
  (value: string) => {
    if (value) return true;
    return "You must enter a task.";
  },
];

const { mutate } = useIssueCreateIssue({
  mutation: {
    onSuccess: ({ data: issue }) => {
      emit("created");
      void router.push({
        name: "/repos/[owner]/[repo]/issues/[index]/",
        params: {
          owner: props.owner,
          repo: props.repo,
          index: `${issue.number}`,
        },
      });
    },
  },
});

async function submit(e: SubmitEventPromise) {
  const { valid } = await e;
  if (valid) {
    mutate({
      owner: props.owner,
      repo: props.repo,
      data: {
        title: task.value,
        ...(description.value && { body: description.value }),
      },
    });
  }
}
</script>
